// extracted by mini-css-extract-plugin
module.exports = {"syntax-display-container":"_39Bj-","syntaxDisplayContainer":"_39Bj-"};